import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import { ConfigTypes, getConfig } from 'projects/sharedComponents/src/services/getConfig/getConfig';

import React from 'react';

const contentfulGraphQLApiConfig = createHttpLink({
  uri: `https://graphql.contentful.com/content/v1/spaces/${getConfig(
    ConfigTypes.CONTENTFUL_SPACE_ID
  )}/environments/${getConfig(ConfigTypes.CONTENTFUL_ENVIRONMENT)}`,
  headers: {
    Authorization: `Bearer ${getConfig(ConfigTypes.CONTENTFUL_API_KEY)}`,
  },
});

const contentfulApolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: contentfulGraphQLApiConfig,
});

export const ContentfulApolloClientProvider: React.FC = ({ children }) => {
  return <ApolloProvider client={contentfulApolloClient}>{children}</ApolloProvider>;
};
